module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-976-retro-min.adff9891.jpg";